import { render, staticRenderFns } from "./order-items-list.vue?vue&type=template&id=f76e0cfc&scoped=true&"
import script from "./order-items-list.vue?vue&type=script&lang=js&"
export * from "./order-items-list.vue?vue&type=script&lang=js&"
import style0 from "./order-items-list.vue?vue&type=style&index=0&id=f76e0cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76e0cfc",
  null
  
)

export default component.exports